import type { Messages } from '../catalogue.en'

export const scheduleReception: Partial<Messages> = {
  'schedule.receptionEdit.title': 'Регистратура',
  'schedule.receptionEdit.edit': 'Изменить',
  'schedule.receptionEdit.empty': 'Пока ничего не записано',
  'schedule.receptionEdit.markUnset': 'Не указано',
  'schedule.receptionEdit.markYes': 'Да',
  'schedule.receptionEdit.markNo': 'Нет',
  'schedule.receptionEdit.stale': 'Визит изменился, пока форма была открыта. Перечитайте его и сохраните снова.',
  'schedule.receptionEdit.reread': 'Перечитать',
  'schedule.receptionEdit.changed': 'Коллега изменил сведения регистратуры, пока форма была открыта. Показано то, что сохранено; чтобы изменить, откройте правку снова.',
  'schedule.receptionEdit.withConfirm': 'Записывается вместе с подтверждением.',
  'schedule.receptionHistory.title': 'История',
  'schedule.receptionHistory.empty': 'Изменений регистратуры не записано',
  'schedule.receptionHistory.loading': 'Читаем историю',
  'schedule.receptionHistory.loadFailed': 'Не удалось загрузить историю',
  'schedule.receptionHistory.loadMore': 'Показать ещё',
  'schedule.receptionHistory.actor': 'Учётная запись',
  'schedule.receptionHistory.changed': 'Изменено',
  'schedule.receptionHistory.firstRecord': 'Первая запись',
  'schedule.impactPanel.resources': 'Затронутые ресурсы',
  'schedule.financeFacts.currency': 'Валюта',
  'schedule.refusal.title': 'Почему отказано',
  'schedule.refusal.blocks': 'Блокирует команду',
  'schedule.refusal.warning': 'Только предупреждение',
  'schedule.refusal.resource': 'Ресурс',
  'schedule.refusal.requirement': 'Требование',
  'schedule.refusal.when': 'Когда',
  'schedule.refusal.existingEvent': 'Конфликтующее событие',
  'schedule.refusal.existingReservation': 'Конфликтующее резервирование',
  'schedule.refusal.field': 'Поле',
}
